$(function() {

  $('.presenter-card__link').on('click', function(e) {
    e.preventDefault()
    
    const parent = $(this).parent();
    const popup = parent.next();

    popup.fadeIn();
  })

  $('.presenter-card__popup-modal').on('click', function(e) {
    if(e.target != $('.presenter-card__popup-container') &&  !e.target.closest('.presenter-card__popup-container')) {
      $(this).fadeOut();
    }
  })

  $('.presenter-card__popup-close-button').on('click', function(e) {
    e.preventDefault();
    $('.presenter-card__popup-modal').fadeOut();
  })
  
})